/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetEncounterPriceErrorResponse, GetEncounterPriceResponse } from './api.schemas';

import { api } from '../util/http';

export const getEncountersPrice = (encounterId: number, signal?: AbortSignal) => {
  return api<GetEncounterPriceResponse>({
    url: `/api/encounters/${encounterId}/price`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersPriceQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/price`] as const;
};

export const getGetEncountersPriceQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersPrice>>,
  TError = GetEncounterPriceErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncountersPrice>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersPriceQueryKey(encounterId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersPrice>>> = ({ signal }) =>
    getEncountersPrice(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersPrice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersPriceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersPrice>>
>;
export type GetEncountersPriceQueryError = GetEncounterPriceErrorResponse;

export function useGetEncountersPrice<
  TData = Awaited<ReturnType<typeof getEncountersPrice>>,
  TError = GetEncounterPriceErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncountersPrice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersPrice>>,
          TError,
          Awaited<ReturnType<typeof getEncountersPrice>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersPrice<
  TData = Awaited<ReturnType<typeof getEncountersPrice>>,
  TError = GetEncounterPriceErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersPrice>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersPrice>>,
          TError,
          Awaited<ReturnType<typeof getEncountersPrice>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersPrice<
  TData = Awaited<ReturnType<typeof getEncountersPrice>>,
  TError = GetEncounterPriceErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncountersPrice>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersPrice<
  TData = Awaited<ReturnType<typeof getEncountersPrice>>,
  TError = GetEncounterPriceErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncountersPrice>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersPriceQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
